// extracted by mini-css-extract-plugin
export var actionText = "_mk-4";
export var container = "_mk-0";
export var leftSection = "_mk-1";
export var rightSection = "_mk-2";
export var settingsButton = "_mk-6";
export var settingsIcon = "_mk-7";
export var shortcut = "_mk-5";
export var shortcutGroup = "_mk-3";